import { ChartListItem, PudoTransactionVolumeByStateListChart } from '@frontend/chart/components';
import { CommonMessage } from '@frontend/lang';
import { TransactionState, TransactionStateName } from '@frontend/transaction/types';
import { LuChevronRight } from 'react-icons/lu';
import { FormattedMessage } from 'react-intl';

import { StatisticsCard } from '../../shared';
import { useLast30DaysPudoTransactionVolumeByStateListChart } from './use-last-30-days-pudo-transaction-volume-by-state-list-chart';

export interface Last30DaysPudoTransactionVolumeByStateListChartProps {
    accountId: string;
}

export const Last30DaysPudoTransactionVolumeByStateListChart = (props: Last30DaysPudoTransactionVolumeByStateListChartProps) => {
    const viewProps = useLast30DaysPudoTransactionVolumeByStateListChart(props);

    const renderItem = (item: ChartListItem) => {
        const state = item.key as TransactionStateName;

        return (
            <div className='flex w-full items-center justify-between'>
                <div className='flex min-w-0 flex-1 flex-col items-start justify-center gap-0.5'>
                    <div className='text-foreground-default justify-start text-base font-semibold'>{item.value}</div>
                    <div className='text-brand-muted justify-start text-base font-medium'>{TransactionState.getByValue(state)?.displayName ?? item.name}</div>
                </div>
                <div
                    onClick={() => viewProps.navigate(viewProps.getNavigateTarget(state))}
                    className='flex h-6 w-6 shrink-0 cursor-pointer items-center justify-center'>
                    <LuChevronRight />
                </div>
            </div>
        );
    };

    return (
        <StatisticsCard
            chartKey={PudoTransactionVolumeByStateListChart.definition.key}
            title={CommonMessage.OBJECTS.TRANSACTION.PLURAL}
            subtitle={
                <FormattedMessage
                    id='widget.last-30-days'
                    defaultMessage='last 30 days'
                />
            }
            isLoading={viewProps.isLoading}
            hasData={!!viewProps.data}>
            {viewProps.data && (
                <div className='min-h-0 flex-1 overflow-y-auto'>
                    <PudoTransactionVolumeByStateListChart
                        data={viewProps.data}
                        renderItem={renderItem}
                    />
                </div>
            )}
        </StatisticsCard>
    );
};
